"use strict";
import { createSyncStoragePersister } from "@tanstack/query-sync-storage-persister";
import { PersistQueryClientProvider } from "@tanstack/react-query-persist-client";
import { SharedQueryClient } from "uniswap/src/data/apiClients/SharedQueryClient";
import { sharedDehydrateOptions } from "uniswap/src/data/apiClients/sharedDehydrateOptions";
import { MAX_REACT_QUERY_CACHE_TIME_MS } from "utilities/src/time/time";
const persistOptions = {
  // Change this unique string whenever we want to bust the entire cache.
  buster: "v0",
  maxAge: MAX_REACT_QUERY_CACHE_TIME_MS,
  persister: createSyncStoragePersister({ storage: localStorage }),
  dehydrateOptions: sharedDehydrateOptions
};
export function QueryClientPersistProvider({ children }) {
  return <PersistQueryClientProvider client={SharedQueryClient} persistOptions={persistOptions}>{children}</PersistQueryClientProvider>;
}
